import { useMutation } from '@tanstack/react-query'
import { initiateCustomersRewardsWithdrawal } from 'services/RewardsService'
import {
  type CustomersEarningsWithdrawalRequest,
  type CustomersRewardsWithdrawalResponse,
} from 'types/rewards'

export const useInitiateCustomersRewardsWithdrawalMutation = () =>
  useMutation<CustomersRewardsWithdrawalResponse, Error, CustomersEarningsWithdrawalRequest>({
    mutationFn: initiateCustomersRewardsWithdrawal,
  })
